module.exports = __webpack_public_path__ + "img/auto.251f42ee.svg";